import React, { useCallback, useRef } from 'react';

import { useStateBus } from '~/state/bridge';
import { getLeadAdEnabled } from '~/state/LeadAds/selectors';

const Dropdown = (props) => {
  const {
    id,
    label,
    className,
    onChange,
    options,
    value,
  } = props;

  const leadAdEnabled = useStateBus(getLeadAdEnabled);

  const selectRef = useRef(null);

  const confirmSelection = useCallback((e) => {
    const newValue = e.target.value;

    if (leadAdEnabled) {
      // TODO: Convert confirmation box to something a little prettier
      // eslint-disable-next-line
      const confirmed = confirm(`Switching your ${label} will reset your Lead Ad progress. Would you like to continue?`);

      if (confirmed) {
        onChange(newValue);
      } else {
        // Reset the value
        selectRef.current.value = value;
      }
    } else {
      onChange(newValue);
    }
  }, [leadAdEnabled, value]);

  return (
    <div className="user-display__field">
      { /* eslint-disable-next-line */}
      <label htmlFor={id}>{ `${label}: ` }</label>
      <select
        value={value || ''}
        className={className}
        name={label}
        id={id}
        onChange={confirmSelection}
        ref={selectRef}
      >
        {
        options && options.map(({ id: optionId, name }) => (
          <option key={optionId} value={optionId}>{ name }</option>
        ))
      }
      </select>
    </div>
  );
};

export default React.memo(Dropdown);
